import { put } from 'redux-saga/effects';
import { apiPost } from 'shared/api';
import * as actions from 'store/actions';

export function* addImportantPlaceSaga(action) {
  yield put(actions.addImportantPlaceStart());
  try {
    const data = {
      FavType: 'Location',
      Location: action.Location,
      Location2: action.Location2,
      MapLat: action.MapLat,
      MapLng: action.MapLng,
      Lat: action.Lat,
      Lng: action.Lng,
    };
    if (action.LocIcon) {
      data.LocIcon = action.LocIcon;
    }
    data.MapType = action.MapType ? action.MapType : 'roadmap';
    data.Pitch = action.Pitch ? action.Pitch : 'NULL';
    data.Heading = action.Heading ? action.Heading : 'NULL';
    data.Zoom = action.Zoom ? action.Zoom : 'NULL';
    yield apiPost('v2_userFavAdd', data);
    yield put(actions.addImportantPlaceSuccess());
  } catch (error) {
    yield put(actions.addImportantPlaceFailed(error.response.data.error_message));
  }
}

export function* updateImportantPlaceSaga(action) {
  yield put(actions.updateImportantPlaceStart());
  try {
    const data = {
      FavId: action.Id,
    };
    if (action.Location) {
      data.Location = action.Location;
    }
    if (action.Location2) {
      data.Location2 = action.Location2;
    }
    if (action.LocIcon) {
      data.LocIcon = action.LocIcon;
    }
    if (action.Delete) {
      data.Delete = true;
    }
    yield apiPost('v2_userFavUpdate', data);
    yield put(actions.updateImportantPlaceSuccess());
  } catch (error) {
    yield put(actions.updateImportantPlaceFailed(error.response.data.error_message));
  }
}

export function* fetchImportantPlacesSaga() {
  yield put(actions.fetchImportantPlacesStart());
  try {
    const result = yield apiPost('v2_userFavs', { FavType: 'Location' });
    yield put(actions.fetchImportantPlacesSuccess(result.data.payload.Favs));
  } catch (error) {
    yield put(actions.fetchImportantPlacesFailed(error.response.data.error_message));
  }
}
